<script lang="ts">
  import { Button, Image } from "sveltestrap";
  let imgPath:string = "/assets/images/ecommerce"
  export let rows
</script>

{#if rows}
  {#each $rows as tableItem}
    <tr class={tableItem.class2}>
      <td class="sorting_1">
        <Image src="{imgPath}/{tableItem.img}" alt="" />
      </td>
      <td>
        <h6>{tableItem.title}</h6>
        <span>{tableItem.detail}</span>
      </td>
      <td>{tableItem.price}</td>
      <td class={tableItem.class}>{tableItem.stock}</td>
      <td>{tableItem.date}</td>
      <td>
        <Button color={tableItem.color1} class="btn-xs">{tableItem.btn1}</Button
        >
        <Button color={tableItem.color2} class="btn-xs">{tableItem.btn2}</Button
        >
      </td>
    </tr>
  {/each}
{/if}
